import EventEmitter from 'eventemitter3';

const EE = new EventEmitter();

export const broadcast = async (ob: Object, event: String, ...args: any) => {
  EE.emit(`${ob}:${event}`, ...args);
};

export const emit = async (event: String, ...args: any) => {
  if (event) {
    EE.emit(event, ...args);
  }
};

export const on = async (event: String, handler?: Function, context?: Object) => {
  if (handler) {
    EE.on(event, handler, context);
  }
};

export const once = async (event: String, handler?: Function, context?: Object) => {
  if (handler) {
    EE.once(event, handler, context);
  }
};

export const remove = async (
  event: String,
  handler?: Function,
  context?: Object,
  doOnce?: Boolean
) => {
  EE.removeListener(event, handler, context, doOnce);
};

export const removeAll = async (event?: String) => {
  EE.removeAllListeners(event);
};

export default {
  broadcast,
  emit,
  on,
  once,
  remove,
  removeAll
};
